export default __webpack_public_path__ + "static/media/r5.2e3d0454.svg";